import { Provider } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const TranslateConfig: Provider[] = provideTranslateService({
  fallbackLang: 'en',
  loader: provideTranslateHttpLoader({ useHttpBackend: true }),
});
